import { useCreateTeam } from "../api/useCreateTeam"
import { useDeleteTeam } from "../api/useDeleteTeam"

export function useTeamMutations() {
  const { createTeam } = useCreateTeam()
  const { deleteTeam } = useDeleteTeam()

  return {
    createTeam,
    deleteTeam
  }
}
